import { IProjectApplicant } from '../../../../interfaces/projectApplicant';
import { IProjectPosition, IProjectPositionStringSkills } from '../../../../interfaces/projectPosition';
import { Modal } from '../../Modal';
import { useGetPositionApplicants } from '../../../../queryHooks/project/position/useGetPositionApplicants';
import { useCallback, useMemo } from 'react';
import { Loader } from '../../Loader';
import { TEXTS } from '../../../../core/texts';
import { Groups } from '@mui/icons-material';
import { Typography } from '@mui/material';
import ApplicantsTable from './ApplicantsTable';

interface IProps {
  onClose: () => void;
  positionEntity: IProjectPosition | IProjectPositionStringSkills;
  handleGetApplicants: (positionId: string) => Promise<IProjectApplicant[]>;
}

const PositionApplicantsModal = ({ onClose, positionEntity, handleGetApplicants }: IProps) => {
  const getApplicantsHandler = useCallback(() => handleGetApplicants(positionEntity.id), [handleGetApplicants, positionEntity]);
  const { data: applicants, isFetching } = useGetPositionApplicants({
    dependency: positionEntity.id,
    handler: getApplicantsHandler,
    onError: () => onClose()
  });
  const applicantsList = useMemo(() => applicants || [], [applicants]);

  return (
    <Modal keepMounted={true} onClose={onClose} maxWidth={1600} minHeight={200} title={TEXTS.APPLICANTS}
           headerIcon={<Groups color={'primary'}/>}>
      {
        isFetching && <Loader width={100}/>
      }
      {
        applicantsList.length
          ? <ApplicantsTable applicants={applicantsList} />
          : <Typography>
            {TEXTS.NO_RECORDS_FOUND}
          </Typography>
      }
    </Modal>
  );
};

export default PositionApplicantsModal;